import styled from 'styled-components';
import { ButtonRounded } from '@comeon/ui';
import { HeadWrapper, MainTitle, SubTitle } from '~/components/misc/section-head';
import Icon, { ICON_EXCLAMATION } from '~/components/icon/index.js';

const StyledMainTitle = styled(MainTitle)`
	font: var(--h2);
	padding: 0 10px 6px 10px;
`;

const StyledButton = styled(ButtonRounded)`
	font-size: 15px;
	padding: 8px 22px;
	margin-top: 50px;
`;

const QRCodeError = ({ mainTitle, subTitle, buttonText, onTryAgain }) => {
	return (
		<HeadWrapper className="u-mt2">
			<Icon className="qr-failure-icon" width="56" height="56" type={ICON_EXCLAMATION} />
			<StyledMainTitle>{mainTitle}</StyledMainTitle>
			<SubTitle className="u-pl1 u-pr1">{subTitle}</SubTitle>
			<StyledButton onClick={onTryAgain}>{buttonText}</StyledButton>
		</HeadWrapper>
	);
};

export default QRCodeError;
